import React from 'react';
import * as firebase from 'firebase';

class ArtistPage extends React.Component {

    componentDidMount() {
        
        if(this.props.match.params.id) {
            const data = firebase.firestore().collection('artists').doc(this.props.match.params.id).collection('publicData').get();
            console.log('got data!', data);

            this.setState({ data });
        }
            
        
    }

    render() {
        return (
            <div>
                Artist page - {this.props.match.params.id}
            </div>
        )
    }
}

export default ArtistPage;